import * as T from 'three';
let logo:HTMLImageElement|undefined;
export async function prepareTvLogo(){
 if(logo)return;
 const image=new Image();image.src='/bliss-bedrooms-logo-transparent.png';
 await image.decode();logo=image;
}
export function tvScreenTexture(){
 if(!logo)return null;
 const canvas=document.createElement('canvas');canvas.width=1024;canvas.height=576;
 const ctx=canvas.getContext('2d')!;ctx.fillStyle='#f7f4ed';ctx.fillRect(0,0,1024,576);
 const scale=Math.min(640/logo.width,390/logo.height),w=logo.width*scale,h=logo.height*scale;
 ctx.drawImage(logo,(1024-w)/2,(576-h)/2,w,h);
 const texture=new T.CanvasTexture(canvas);texture.colorSpace=T.SRGBColorSpace;return texture;
}
